import {
  AUTO_REDIRECTED_TO_BETTER_LANGUAGE,
  CAMPAIGN,
  COOKIE_CONSENT,
  INTERNAL_ANALYTICS,
  MANUAL_AND_APP_LANGUAGE,
} from './serve/consts';
import {clear, get, set} from './serve/localStorage';

const KEEP_KEYS = [
  CAMPAIGN,
  INTERNAL_ANALYTICS,
  COOKIE_CONSENT,
  MANUAL_AND_APP_LANGUAGE,
  AUTO_REDIRECTED_TO_BETTER_LANGUAGE,
];

export function clearLocalStorage() {
  const preserved = new Map<string, unknown>();

  KEEP_KEYS.forEach((key) => {
    const value = get(key);

    if (!value) {
      return;
    }

    preserved.set(key, value);
  });

  clear();

  preserved.forEach((value, key) => {
    set(key, value);
  });
}
